"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PINPager = void 0;
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var PINPager = function (props) { return (React.createElement("ul", { className: "pinpager " + (props.className || "") }, Array.apply(null, { length: props.count < 0 ? 0 : props.count }).map(function (_, i) { return (React.createElement("li", { key: "pinpager" + i + props.current + props.className, className: "pinpager-bullet" + (props.current === i ? " current" : "") })); }))); };
exports.PINPager = PINPager;
PINPager.propTypes = {
    count: PropTypes.number.isRequired,
    current: PropTypes.number
};
//# sourceMappingURL=PINPager.js.map